import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlertsPaged } from "app/models/alerts/alert-list.model";
import { CasesPaged } from "app/models/cases/cases-list.model";
import { ComplaintType } from "app/models/complaints/complaint.interface";
import { StepFilteredDto, StepResultDto } from "app/models/dynamic-filters/dynamic-filters.model";
import { Form } from "app/models/form";
import { Item } from "app/models/item.inferface";
import { WorkflowFilterDto } from "app/models/workflow/workflow.interface";
import { Observable, of } from "rxjs";
import { ConfigsLoaderService } from "./config-loader.service";

@Injectable({
    providedIn: 'root'
})

export class DynamicFiltersService {

    private readonly useMockData = false;
    private readonly apiEndpoint: string;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndpoint = this.config.apiUrl;
    }

    getWorkflowsByTypes(workflowFilter: WorkflowFilterDto): Observable<Item[]> {
        return this.httpClient.post<Item[]>(`${this.apiEndpoint}/DynamicFilters/Workflow`, workflowFilter);
    }

    getStepsByWorkflowId(workflowId: number): Observable<StepResultDto[]>{
        return this.httpClient.get<StepResultDto[]>(`${this.apiEndpoint}/DynamicFilters/Step/${workflowId}`);
    }

    applyFiltersAlert(dataFiltered: StepFilteredDto): Observable<AlertsPaged>{
        return this.httpClient.post<AlertsPaged>(`${this.apiEndpoint}/DynamicFilters/GetPagedAlert`, dataFiltered);
    }

    applyFiltersAlertByComplaint(dataFiltered: StepFilteredDto): Observable<AlertsPaged>{
        return this.httpClient.post<AlertsPaged>(`${this.apiEndpoint}/DynamicFilters/GetPagedAlertByComplaint`, dataFiltered);
    }

    getComplaintTypes(){
        return this.httpClient.get<ComplaintType[]>(`${this.apiEndpoint}/Complaint/GetTypes`);
    }

    getComplaintForm(formTypeId:number, formSubTypeId: number){
        return this.httpClient.get<Form>(`${this.apiEndpoint}/Complaint/FormConfig/${formTypeId}/${formSubTypeId}`);
    }

    applyFiltersProceedingReport(dataFiltered: StepFilteredDto[]) {
        return this.httpClient.post(`${this.apiEndpoint}/Report/RequestDynamicFilesReport`, dataFiltered);
    }

    applyFiltersAlertReport(dataFiltered: StepFilteredDto[]) {
        return this.httpClient.post(`${this.apiEndpoint}/Report/RequestDynamicAlertReport`, dataFiltered);
    }

    exportAlertsPdf(dataFiltered: StepFilteredDto): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/DynamicFilters/ExportPdf`, dataFiltered);
    }

    exportAlertsExcel(dataFiltered: StepFilteredDto): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/DynamicFilters/ExportExcel`, dataFiltered);
    }

    applyFiltersComplaintReport(dataFiltered: StepFilteredDto[]){
        return this.httpClient.post(`${this.apiEndpoint}/Report/RequestDynamicComplaintReport`, dataFiltered);
    }

    exportAlertsByComplaintPdf(dataFiltered: StepFilteredDto): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/DynamicFilters/ExportPDFAlertByComplaint`, dataFiltered);
    }

    exportAlertsByComplaintExcel(dataFiltered: StepFilteredDto): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/DynamicFilters/ExportExcelAlertByComplaint`, dataFiltered);
    }

    applyFiltersCase(dataFiltered: StepFilteredDto): Observable<CasesPaged>{
        return this.httpClient.post<CasesPaged>(`${this.apiEndpoint}/DynamicFilters/GetPagedCase`, dataFiltered);
    }

    applyFiltersCaseByAlert(dataFiltered: StepFilteredDto): Observable<CasesPaged>{
        return this.httpClient.post<CasesPaged>(`${this.apiEndpoint}/DynamicFilters/GetPagedCasesByAlerts`, dataFiltered);
    }

    applyFiltersCaseReport(dataFiltered: StepFilteredDto[]){
        return this.httpClient.post(`${this.apiEndpoint}/Report/RequestDynamicCaseReport`, dataFiltered);
    }
}